<template>
  <div class="center-container">
    <span class="text-center ">הורידו את האפליקציה, ותהינו מחווית משתמש שלא הכרתם, התראות בזמן אמת ועוד! </span>
    <div class="flex justify-between gap-6 flex-row mt-4 px-1">
      <a
        href="https://apps.apple.com/il/app/timeit-%D7%A0%D7%99%D7%94%D7%95%D7%9C-%D7%A2%D7%A1%D7%A7-%D7%91%D7%99%D7%95%D7%98%D7%99/id6466124526"
        target="_blank"
        @click="() => {event('business-site-confirmation-download-app-store-clicked'); trackEvent('download_app_clicked', { store: 'app_store' });}">
        <img src="../../../../assets/img/admin/download-app-store.png" alt="Download from AppStore"/>
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.timeit.app"
        target="_blank"
        @click="() => {event('business-site-confirmation-download-play-store-clicked'); trackEvent('download_app_clicked', { store: 'play_store' });}">
        <img
          src="../../../../assets/img/admin/download-google-play.png"
          alt="Download from Google Play Store"/>
      </a>
    </div>
  </div>
</template>

<script setup lang="ts">
import {event} from 'vue-gtag'
import { trackEvent } from '@app/composables/posthog';

event('business-site-confirmation-view')
trackEvent('download_app_banner_viewed');

</script>

<style scoped lang="scss">
.center-container {
  display: flex;
  flex-grow: 1;
  width: 100%;
  flex-direction: column;
  overflow: auto;
  grid-area: 1 / 1;
  z-index: 1;
}
</style>
